// https://app.growthbook.io/features/pen-6698_v1
export const PEN_6698_V1_CM_INSTRUCTOR_ACCOLADE_MODAL_FLAG_NAME = 'pen-6698_v1'
